import axios from 'components/Axios';
import { Company } from '../APIEndPoint';

const UpdateCompanyProfile = (payload) => {
  const promise = axios.post(`${Company}`, payload);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const GetCompanyImagesById = (username) => {
  const promise = axios.get(`${Company}/images/byUserName/${username}`);
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

const GetCompanyProfileById = (username) => {
  const promise = axios.get(`${Company}/byUserName/${username}`);
  const dataPromise = promise.then((response) => response);

  return dataPromise;
};

const updateAndAddImagesById = (data, method) => {
  const promise = axios({url: `${Company}/images`, data, method });
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

export const DeleteCompanyImagesById = (payload, attachment) => {
  const promise = axios.delete(`${Company}/images`, {
    data: {
      index: [payload],
      attachment: [attachment]
    },
  });
  const dataPromise = promise.then((response) => response);
  return dataPromise;
};

export {
  UpdateCompanyProfile,
  GetCompanyProfileById,
  GetCompanyImagesById,
  updateAndAddImagesById,
};
